import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import Audiobooks from "./views/Audiobooks.vue";
import AudiobooksDetail from "./views/AudiobooksDetail.vue";
import Authors from "./views/Authors.vue";
import AuthorsDetail from "./views/AuthorsDetail.vue";
import ArticleAuthors from "./views/ArticleAuthors.vue";
import ArticleAuthorsDetail from "./views/ArticleAuthorsDetail.vue";
import Content from "./views/Content.vue";
import Blog from "./views/Blog.vue";
import BlogDetail from "./views/BlogDetail.vue";
import Customers from "./views/Customers.vue";
import CustomersDetail from "./views/CustomersDetail.vue";
import Orders from "./views/Orders.vue";
import OrdersDetail from "./views/OrdersDetail.vue";
import Overview from "./views/Overview.vue";
import Publishers from "./views/Publishers.vue";
import PublishersDetail from "./views/PublishersDetail.vue";
import Interprets from "./views/Interprets.vue";
import InterpretsDetail from "./views/InterpretsDetail.vue";
import Sales from "./views/Sales.vue";
import SalesImport from "./views/SalesImport.vue";
import Settings from "./views/Settings.vue";
import Widgets from "./views/Widgets.vue";
import Stats from "./views/Stats.vue";
import Vouchers from "./views/Vouchers.vue";
import VouchersDetail from "./views/VouchersDetail.vue";
import Categories from "./views/Categories.vue";
import Generating from "./views/Generating.vue";
import CategoriesDetail from "./views/CategoriesDetail.vue";
import Pages from "./views/Pages.vue";
import PagesDetail from "./views/PagesDetail.vue";
import Billing from "./views/Billing.vue";
import BillingAll from "./views/BillingAll.vue";

import BillingImport from "./views/BillingImport.vue";
import BillingImportMake from "./views/BillingImportMake.vue";

import Files from "./views/Files.vue";
import FilesDetail from "./views/FilesDetail.vue";

import Notifications from "./views/Notifications.vue";
import NotificationsNew from "./views/NotificationsNew.vue";
import NotificationsDetail from "./views/NotificationsDetail.vue";
import PromoBar from "./views/PromoBar.vue";
import PromoBarDetail from "./views/PromoBarDetail.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/notifications",
      name: "Notifications",
      component: Notifications,
    },
    {
      path: "/notifications/:id",
      name: "NotificationsDetail",
      component: NotificationsDetail,
    },
    {
      path: "/notifications/add",
      name: "Notifications-new",
      component: NotificationsNew,
    },
    {
      path: "/files",
      name: "Files",
      component: Files,
    },
    {
      path: "/files/:id",
      name: "FilesDetail",
      component: FilesDetail,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/pages",
      name: "Pages",
      component: Pages,
    },
    {
      path: "/pages/:id",
      name: "PagesDetail",
      component: PagesDetail,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/audiobooks",
      name: "Audiobooks",
      component: Audiobooks,
    },
    {
      path: "/audiobooks/:id",
      name: "AudiobooksDetail",
      component: AudiobooksDetail,
    },
    {
      path: "/authors",
      name: "Authors",
      component: Authors,
    },
    {
      path: "/authors/:id",
      name: "AuthorsDetail",
      component: AuthorsDetail,
    },
    {
      path: "/article-authors",
      name: "ArticleAuthors",
      component: ArticleAuthors,
    },
    {
      path: "/article-authors/:id",
      name: "ArticleAuthorsDetail",
      component: ArticleAuthorsDetail,
    },
    {
      path: "/content",
      name: "Content",
      component: Content,
    },
    {
      path: "/widgets",
      name: "Widgets",
      component: Widgets,
    },
    {
      path: "/generating",
      name: "Generating",
      component: Generating,
    },
    {
      path: "/blog",
      name: "Blog",
      component: Blog,
    },
    {
      path: "/blog/:id",
      name: "BlogDetail",
      component: BlogDetail,
    },
    {
      path: "/customers",
      name: "Customers",
      component: Customers,
    },
    {
      path: "/customers/:id",
      name: "CustomersDetail",
      component: CustomersDetail,
    },
    {
      path: "/orders",
      name: "Orders",
      component: Orders,
    },
    {
      path: "/orders/:id",
      name: "OrdersDetail",
      component: OrdersDetail,
    },
    {
      path: "/overview",
      name: "Overview",
      component: Overview,
    },
    {
      path: "/publishers",
      name: "Publishers",
      component: Publishers,
    },
    {
      path: "/publishers/:id",
      name: "PublishersDetail",
      component: PublishersDetail,
    },
    {
      path: "/interprets",
      name: "Interprets",
      component: Interprets,
    },
    {
      path: "/interprets/:id",
      name: "InterpretsDetail",
      component: InterpretsDetail,
    },
    {
      path: "/sales",
      name: "Sales",
      component: Sales,
    },
    /*   {
          path: '/sales/import/:id',
          name: 'SalesImport',
          component: SalesImport
      },*/
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
    },
    /*  {
          path: '/stats',
          name: 'Stats',
          component: Stats
      },*/
    {
      path: "/billing-export",
      name: "Billing",
      component: Billing,
    },
    {
      path: "/billing-import",
      name: "BillingImport",
      component: BillingImport,
    },
    {
      path: "/billing-import/make",
      name: "BillingImportMake",
      component: BillingImportMake,
    },
    {
      path: "/billing",
      name: "BillingAll",
      component: BillingAll,
    },
    {
      path: "/vouchers",
      name: "Vouchers",
      component: Vouchers,
    },
    {
      path: "/vouchers/:id",
      name: "VouchersDetail",
      component: VouchersDetail,
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories,
    },
    {
      path: "/categories/:id",
      name: "CategoriesDetail",
      component: CategoriesDetail,
    },
    {
      path: "/promo-bar",
      name: "PromoBar",
      component: PromoBar,
    },
    {
      path: "/promo-bar/:id",
      name: "PromoBarDetail",
      component: PromoBarDetail,
    },
    {
      path: "*",
      redirect: "/dashboard",
      component: Dashboard,
    },
  ],
});
